import { Component, OnInit, ViewChild, Input, ElementRef } from '@angular/core';
import { CommonService } from 'src/app/core/services/common-service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import {
  customerProposalDetailsModal, RejectProposal, getOTPForCustomerProposalAcceptanceModel,
  validateOTPForCustomerProposalAcceptanceModel, CustomerProposalListModal,
  EditCustomerProposalSaveModal,
  FinancierDetails
} from 'src/app/core/models/customerProposalDetails';
import { customerProposalService } from 'src/app/core/services/customerProposal.service.';
import { CreateQuoteService } from 'src/app/core/services/create-quote-service';
import { fakeAsync } from '@angular/core/testing';
import { PaymentPendingService } from 'src/app/core/services/payment-pending.service';
import { updateProposalToPolicyModel } from 'src/app/core/models/updateProposalToPolicy';
import { NotificationService } from 'src/app/core/services/notification.service';
import { NewQuoteService } from 'src/app/core/services/new-quote.service';
import { timeoutWith } from 'rxjs/operators';
import { DatePipe, formatDate } from '@angular/common';
import { NgForm } from '@angular/forms';
import JSZip from 'jszip';

import { CommonMethodService } from 'src/app/core/services/common.method-service';
import product_related from 'src/assets/FAQs/wc-customer_faqs/product_related.json';
import general from 'src/assets/FAQs/customer_faqs/general.json';
import { FinancierDetailsComponent } from 'src/app/shared/components/financier-details/financier-details.component';
import { UploadedFileObj } from 'src/app/core/models/uploadedDocumentDetails';
import { NewProposalService } from 'src/app/core/services/new-proposal.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { PreviousPolicyDetailsComponent } from '../../new-proposal/previous-policy-details/previous-policy-details.component';
declare var $: any;


@Component({
  selector: 'app-wc-customer-proposal',
  templateUrl: './wc-customer-proposal.component.html',
  styleUrls: ['./wc-customer-proposal.component.css'],
  standalone: false
})
export class WcCustomerProposalComponent implements OnInit {
  refactoredJsonObj: any = [];
  previousPolicyData = [];
  token: any = '';
  searchText: any;
  showRisk: boolean;
  CCWEInfo: any;
  isENPendingQC: boolean;
  isPremiumCalculated: boolean;
  filtersLoaded: Promise<boolean>;
  dataToDownloadBrochure = {
    productCode: '',
    documentType: 'BROCHURE'
  };
  @ViewChild('validatePrevPolicyDetailsComponent') private PreviousPolicyDetailsComponent: PreviousPolicyDetailsComponent;
  @ViewChild('validateFinancierDetailsComponentForm',) private financierDetailsComponent: FinancierDetailsComponent;
  financierDetailsFormValid: boolean;
  dataToDownloadPolicyWordings = { productCode: '', documentType: 'POLICYWORDINGS' }
  generalFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = product_related;
  generalallFAQs: { question: string, is_answer_multiple: boolean, answer: string[] }[] = general;

  customerRejectCommentsDetails = {
    comment: '',
    userCode: '',
    createdBy: '',
    time: '',
  }
  endDate: Date;
  ifProposalRejected = false;
  ifProposalAccepted = false;
  isEditCustomerProposal = false;
  isCustomerProposalMakePayment = false;
  premiumBreakUpAddonCovglist = [
    ['Terrorism Premium', null],
    ['Terrorism for Add-on  Premium', null],
    ['Forest Fire Premium', null],
    ['Architects, Surveyors Premium', null],
    ['Loss of Rent Premium', null],
    ['Additional Expense of Rent Premium', null],
    ['Removal of Debris Premium', null],
    ['Impact Damage Premium', null],
    ['Omission Premium', null]
  ];
  premiumBreakUpBasicCovglist = [
    ['Basic Premium', null],
    ['STFI Premium', null],
    ['Earthquake Premium', null]
  ]
  rejectCustomerProposal = new RejectProposal();
  tempProposalNumber: string;
  downloadAllKey: string;
  acceptProposalOtpResponse: any;
  dataForPdf: any;
  blob: Blob;
  isOTPInvalid: boolean;
  isOTPTimedOut: boolean;
  paymentResponse: any;
  financierList: any;
  salutationList: any;
  customerTypeList: any;
  masterDataForQuote: any;
  agreementData: any;
  customerProposalTotalResponse: any;
  customerProposalRateList: any;
  policyStartDate: any;
  DateofBirthEditProposal: any;
  isCheckSelected = false;
  isCustomerProposalMakePaymentSuccess: boolean;
  customerProposalEditParams: any = {};
  coveragesList: any;
  coverageItem = {
    coverageName: '',
    sumInsured: '',
    indemnityPeriod: ''
  };
  saveEditCustomerProposalList = new EditCustomerProposalSaveModal();
  customerProposalList = new CustomerProposalListModal();
  customerProposalEdit = new CustomerProposalListModal();
  submitted = false;
  isDobInvalid: boolean;
  dobFutureDate: boolean;
  isMobilenumber2InValid: boolean;
  isMobilenumberInValid: boolean;
  isAlEmailIdInValid: boolean;
  isEmailIdInValid: boolean;
  isPolicyStartDate: boolean;
  isPaymentByAgentBehalfIndicator: any;
  isPaymentByAgentBehalfInd: any;
  isPinCodeValid: boolean;
  PincodeMasterData: any;
  PinCodeList: any;
  promise: any;
  ifRequestAgentToPayment: boolean;
  isPaymentBehalfCustomer: boolean;
  isCustomerRejectionCommentsInvalid: boolean;
  emptyFieldError: boolean;
  selectedType: any;
  isInclusionofFinancierChecked: boolean;
  isAnyOtherNilEndorsementChecked: boolean;
  isChangeinClientDetailsChecked: boolean;
  isUPDateGSTNChecked: boolean = false;
  isAdditionOccupancyChecked: boolean = false;
  isIncreaseinEmployeesChecked: boolean = false;
  endorsementType: any;
  disableAllEn = false;
  isEndorsement = false;
  newPolicyDetails: any;
  oldPolicyDetails: any;
  premiumAfterCalculateNull: boolean;
  date: Date;
  policyEndDateToSavePeoposal: string;
  ifEndorsementPassed: boolean = false;
  addedCoverage: boolean;
  dateofbirth: Date;
  rsmTypeArray: [];
  previousPolicyFormValid: boolean;
  coveragesUW: any = [];
  lineOfBusinessCode: number;
  disabled: boolean = true;
  causeofLoss: string[] =
    // [
    //   "Accidental Fire damage (Basic cover for Fire)",
    //   "Storm, Tempest, Flood and Inundation (STFI) Damage",
    //   "Short Circuit fire (Basic Cover for fire)",
    //   "Earthquake (Fire and Shock) (Earthquake)",
    //   "Explosion / Implosion – Non Nuclear (Basic Cover for fire)",
    //   "Landslide including Rock slide (Basic Cover for fire)",
    //   " Nuclear Explosion, Radiation, Breakdown (Basic cover for fire)",
    //   "Overflowing of water Tanks, Apparatus and Pipes (Basic cover for fire)",
    //   "Tsunami/Tidal Waves(Earthquake)",
    //   "Others"
    // ];
    [
      "Death",
      "Permanent Total Disablement",
      "Permanent Partial Disablement",
      "Temporary Total Disablement",
      "Accidental Injury",
      "Others"
    ];
  policyList = [];
  policyData = {
    PreviousInsurerName: '',
    PreviousPolicyNumber: '',
    PreviousPolicyStartdate: '',
    PreviousPolicyEnddate: '',
    PastClaimLodged: 'N',
    ClaimAmountPaidandOutstanding: '',
    ClaimRemarks: '',
    causeOfLossForPolicy: '',
    causeofOtherForPolicy: ''
  };
  textCountFor = 0;
  textCountForReject = 0;
  financierDetails = new FinancierDetails();
  policyNumberToDownload: any;
  customerCommunicationDetails: any;
  endorsementNumbertoDownload: any;
  fieldNameArray = ['LocationID',
    'UserRole',
    'UserId',
    'ModeOfOperation',
    'EndorsementName',
    'EndorsementCode',
    'EndtCalcType',
    'EndorsementTime',
    'EndorsementWording',
    'EndorsementDate',
    'ProposalNo',
    '0',
    '1',
    'IsEditableRateRequired',
    'businessSourceType',
    'IntermediaryID',
    'IntermediaryID',
    'middleName',
    'servicingBranch',
    'salesManagerFirstName',
    'salesManagerLastName',
    'salesManagerEmail',
    'salesManagerMobNo',
    'salesManagerSalutation',
    'salesManagerNid',
    'salesManagerAltMobNo',
    'channel',
    'AuthToken',
    'intermediaryDetails',
    "wagesOfAllOccupancies",
    "numberOfWorkers",
    'ProposalNumber',
    'LobCode',
    'ProductCode',
    'IMDCode',
    'customerType',
    'riskPinCode',
    'userID',
    'name',
    'role',
    'isLimitOfIdemnity',
    'endorsementNumber',
    'status',
    'OfficeCode',
    'userNid',
    'gcProposalNumber',
    'refundPremium',
    'premiumWithStampDuty',
    'premiumWithGST',
    'MASRate',
    'intermediaryServicingAddressDetails',
    'sumInsured',
    'PASTPOLICYDETAILS.causeOfLossForPolicy.1',
    'PASTPOLICYDETAILS.causeofOtherForPolicy.1'
  ]
  diffArray: any[];
  copyOfProposalNumber: any;
  pincodeminlimit = false;
  notfound: boolean;
  pastPaymentPolicy: boolean;
  duplicatePaymentPolicy: boolean;
  todayDate: any;
  proposalLists: any;
  todayDate1: string;
  ;
  risk_date: string;
  customerTypeError: boolean = false;


  constructor(private newProposalService: NewProposalService, private datePipe: DatePipe, private el: ElementRef, public commonService: CommonService, public datepipe: DatePipe, private newQuoteService: NewQuoteService, private router: Router,
    private route: ActivatedRoute, private customerProposalService: customerProposalService, private createQuoteService: CreateQuoteService,
    private paymentService: PaymentPendingService, private notifyService: NotificationService, public commonMethodService: CommonMethodService, private loaderService: LoaderService) { }
  customerDetailsList: any;
  customerDetailsForGetOtpParams = new getOTPForCustomerProposalAcceptanceModel();
  customerDetailsForValidateOtpParams = new validateOTPForCustomerProposalAcceptanceModel();
  proposalsToPolicyParams = new updateProposalToPolicyModel();
  searchParams = {
    imdCode: '',
    token: this.token,
  };

  inputForPayment = {
    paymentDetails: {
      transactionId: '94204CE9030820162402E1DK',
      amount: 0,
      productInfo: '',
      firstName: '',
      emailAddress: '',
      phoneNumber: '',
      proposalNo: '',
      activityName: 'customer proposal',
      proposalNoList: []

    }
  };
  proposalInput = {
    proposalNumber: '',
    modeofOperation: '',
    // endorsmentNumber:''
  };
  productCode = '1198';
  customer: any;
  maskedMobileNumber: string;
  setRotate0 = false;
  setRotate1 = false;
  setRotate2 = false;
  setRotate3 = false;
  setRotate4 = false;
  setRotate5 = false;
  setRotate6 = false;
  setRotate7 = false;
  @ViewChild("accordionPanel0", { static: false }) accordionPanel0: ElementRef;
  @ViewChild("accordionPanel1", { static: false }) accordionPanel1: ElementRef;
  @ViewChild("accordionPanel2", { static: false }) accordionPanel2: ElementRef;
  @ViewChild("accordionPanel3", { static: false }) accordionPanel3: ElementRef;
  @ViewChild("accordionPanel4", { static: false }) accordionPanel4: ElementRef;
  @ViewChild("accordionPanel5", { static: false }) accordionPanel5: ElementRef;
  @ViewChild("accordionPanel6", { static: false }) accordionPanel6: ElementRef;
  displayEditButtonForEndorsement: boolean;
  riskTypes = [];
  ngOnInit() {
    // //console.log(this.generalFAQs);
    this.customerProposalEditParams.riskFeatureDiscountOrLoading ??= { riskManagementType: {} };
    this.customerProposalEditParams.riskFeatureDiscountOrLoading.riskManagementType ??= {};
    this.route.queryParams.subscribe(params => {
      if ('proposalNo' in params) {
        this.tempProposalNumber = params.proposalNo;
      } else if ('proposalNumber' in params) {
        this.tempProposalNumber = params.proposalNo;
      }
      if (this.tempProposalNumber && this.tempProposalNumber.charAt(0).toUpperCase() == 'P' && Object.keys(params).length == 1) {
        return;
      } else if ('txnid' in params) {
        if (this.tempProposalNumber && this.tempProposalNumber.charAt(0).toUpperCase() == 'P') {
          return;
        }
      }
      this.customerProposal(this.tempProposalNumber);
      this.copyOfProposalNumber = params.proposalNo;

      // this.tempProposalNumber = this.customerProposalTotalResponse.proposalNumber;

      // this.customerProposal(this.tempProposalNumber);

      // this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
      //   this.isPaymentByAgentBehalfIndicator = res;
      // });
      if (Object.keys(params).length > 1) {
        this.paymentResponse = params;
        this.updateTransactionDetailsAfterPayment();
      }
    });
    this.agreementTypeData();
    this.getCustomerTypeList();
    setTimeout(() => {
      this.tooltipInit();
    }, 2000);

    setTimeout(() => {
      this.tooltipInit();
    }, 6000);

    setTimeout(() => {
      this.tooltipInit();
    }, 10000);
    // this.getCCWEInfo();

  }

  clearSearchText() {
    this.searchText = '';
  }

  isfinancierDetailsFormValid(formValid: any) {
    this.financierDetailsFormValid = formValid;
  }

  rotateIcon(iconId: number) {
    switch (iconId) {
      case 0:
        this.setRotate0 = !this.setRotate0;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel0");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 1:
        this.setRotate1 = !this.setRotate1;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel1");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 2:
        this.setRotate2 = !this.setRotate2;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel2");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 3:
        this.setRotate3 = !this.setRotate3;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel3");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 4:
        this.setRotate4 = !this.setRotate4;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel4");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 5:
        this.setRotate5 = !this.setRotate5;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel5");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
      case 6:
        this.setRotate6 = !this.setRotate6;
        setTimeout(() => {
          let acc = document.getElementById("accordionPanel6");
          window.scrollTo({
            top: acc.offsetTop - 175,
            left: acc.offsetLeft,
            behavior: 'smooth'
          })
        }, 10);
        break;
    }
  }


  tooltipInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });
  }
  // Only AlphaNumeric
  keyPressAlphaNumeric(event) {

    var inp = String.fromCharCode(event.keyCode);

    if (/[a-zA-Z0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    if (firstInvalidControl != null) {
      if (!firstInvalidControl.closest(".panel-collapse").classList.contains("show")) {
        firstInvalidControl.closest(".panel-collapse").classList.add("show");
      }

      this.scrollToElement(firstInvalidControl);
      $(firstInvalidControl).focus();
      // firstInvalidControl.focus(); //without smooth behavior
    }
  }
  scrollToElement($element): void {
    $element.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
  }

  downloadCustomerProposalDataBrochure() {
    this.dataToDownloadBrochure.productCode = '36';
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadBrochure).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'Brochure.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }

  getwcProposalDataForDownload() {
    this.commonService.getwcProposalDataToDownload(this.tempProposalNumber).subscribe(res => {
      const dataForPDF: any = res;
      this.blob = new Blob([dataForPDF], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(this.blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = this.tempProposalNumber + '.pdf';
      link.click();
    });
  }

  downloadCustomerPolicyWordings() {
    this.dataToDownloadPolicyWordings.productCode = this.customerDetailsList.ProductCode;
    this.commonService.downloadCustomerProposalDataBrochure(this.dataToDownloadPolicyWordings).subscribe(
      (res) => {
        this.dataForPdf = res;
        this.blob = new Blob([this.dataForPdf], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = 'PolicyWordings.pdf';
        link.click();
      },
      (error: HttpErrorResponse) => {
      }
    );
  }
  checkLength(data) {
    if (data.riskDetails.riskAddress.riskLocations[0] == '') {
      this.showRisk = false;
    }

  }
  isPreviousPolicyFormValid(formValid: any) {
    this.previousPolicyFormValid = formValid;
  }

  highlightingUpdatedData(prop, dynamincProp?: any) {
    prop = dynamincProp !== undefined ? `${prop}.${dynamincProp}` : prop;
    let matchFound = false;
    if (this.diffArray) {
      this.diffArray.forEach(UpdatedDifRecord => {
        if (UpdatedDifRecord.key == prop) {
          matchFound = true;
        }
        if (UpdatedDifRecord.key == "riskLocation") {
          UpdatedDifRecord.value1 = 'Any Where in India'
          UpdatedDifRecord.value2 = 'Specific Location in India'
        }
      });
    }
    return matchFound;
  }

  customerProposal(temp) {
    this.ifRequestAgentToPayment = false;
    this.searchParams.imdCode = this.commonService.getUserName();
    this.searchParams.token = this.token;
    this.customerProposalService.getWCCustomerProposalDetails(temp).subscribe((res: any) => {
      this.customerDetailsList = res.inputRequest;
      // if (this.customerDetailsList && this.customerDetailsList.customerDetails && this.customerDetailsList.customerDetails.customerType == 'I') {
      //   this.customerDetailsList.customerDetails.customerType = 'Individual';
      // } else if (this.customerDetailsList && this.customerDetailsList.customerDetails && this.customerDetailsList.customerDetails.customerType == 'C') {
      //   this.customerDetailsList.customerDetails.customerType = 'Corporate';
      // } else if (this.customerDetailsList && this.customerDetailsList.customerDetails && this.customerDetailsList.customerDetails.customerType == 'G') {
      //   this.customerDetailsList.customerDetails.customerType = 'Govt.Undertaking';
      // }

      this.customerDetailsList.policyStartDate = res.policyStartDate;
      this.customerDetailsList.policyEndDate = res.policyEndDate;
      if (this.customerDetailsList.policyEndDate.includes('T')) {
        this.customerDetailsList.policyStartDate = this.customerDetailsList.policyStartDate.substring(8, 10) + "/" + this.customerDetailsList.policyStartDate.substring(5, 7) + "/" + this.customerDetailsList.policyStartDate.substring(0, 4);
        this.customerDetailsList.policyEndDate = this.customerDetailsList.policyEndDate.substring(8, 10) + "/" + this.customerDetailsList.policyEndDate.substring(5, 7) + "/" + this.customerDetailsList.policyEndDate.substring(0, 4)
      }
      this.customerDetailsList.customerDetails.panNumber = this.customerDetailsList.customerDetails.panNumber;
      if (this.customerDetailsList.EndorsementName == 'Any other Non-Nil Endorsement') {
        this.isPaymentByAgentBehalfInd = true
      } else {
        //console.log(this.customerDetailsList.EndorsementName)
        this.isPaymentByAgentBehalfInd = false
      }

      if (this.customerDetailsList.financier && this.customerDetailsList.financier.financierDetails && this.customerDetailsList.financier.financierDetails.length == 0) {
        this.financierDetails.agreementType = '';
        this.financierDetails.financierName = '';
        this.financierDetails.financierAddress = '';
        this.financierDetails.loanAccountNumber = '';
        this.customerDetailsList.financier.financierDetails.push(this.financierDetails);
      }
      this.checkLength(this.customerDetailsList);
      if (this.isEndorsement) {
        this.validateDisplayEditButtonForEndorsement();
      }
      this.coveragesUW = this.customerDetailsList.coverages.addOnCoverages;
      if (this.customerDetailsList.riskFeatureDiscountOrLoading && this.customerDetailsList.riskFeatureDiscountOrLoading.riskManagementType && this.customerDetailsList.riskFeatureDiscountOrLoading.riskManagementType.riskTypes) {
        this.rsmTypeArray = this.customerDetailsList.riskFeatureDiscountOrLoading.riskManagementType.riskTypes.filter(item => item.isChecked == true);
      }
      this.endDate = this.customerDetailsList.policyEndDate;
      this.customerProposalTotalResponse = res;
      this.filtersLoaded = Promise.resolve(true);
      this.proposalInput.modeofOperation = this.customerDetailsList.ModeOfOperation;
      this.proposalInput.proposalNumber = this.customerProposalTotalResponse.proposalNumber
      if (this.customerProposalTotalResponse && this.customerProposalTotalResponse.endorsementNumber && this.customerProposalTotalResponse.endorsementNumber.includes('EN')) {
        this.tempProposalNumber = this.customerProposalTotalResponse.endorsementNumber;
      } else {
        this.tempProposalNumber = this.customerProposalTotalResponse.proposalNumber;
      }
      this.CCWEInfo = this.customerProposalTotalResponse.brmsResponse;

      this.isEndorsement = this.tempProposalNumber.includes('EN') ? true : false;
      this.isEndorsement ? this.proposalInput['endorsmentNumber'] = this.tempProposalNumber : this.proposalInput['proposalNumber'] = this.tempProposalNumber;

      this.getUploadedDocuments(this.tempProposalNumber);
      if (!this.isEndorsement) {
        this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
          this.isPaymentByAgentBehalfIndicator = res;
        });
      }

      if ('premiumData' in this.customerProposalTotalResponse) {
        this.premiumAfterCalculateNull = true;
        this.mapPremiumBreakUpForAddonCovers(res.premiumData);
        this.mapPremiumBreakUpForBasicCovers(res.premiumData);
      } else {
        this.premiumAfterCalculateNull = false;
      }
      this.mapCoverages();
      this.getWCProposalCoveragesList();
      localStorage.setItem('gc_proposalNo', res.gcProposalNumber);
      localStorage.setItem('CustomerID', res.customerId);
      localStorage.setItem('ProposalNumber', res.proposalNumber);
      this.maskedMobileNumber = this.customerDetailsList.customerDetails.mobileNumber.toString().replace(/^(\d{3})\d(?=\d{3})|\d(?=\d{3})/g, '$1*');
      if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
        this.newPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.inputRequest));
        this.oldPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.oldPolicyDetails.inputRequest));
        delete this.oldPolicyDetails.intermediaryDetails;
        delete this.newPolicyDetails.intermediaryDetails;
        delete this.oldPolicyDetails.intermediaryServicingAddressDetails;
        delete this.newPolicyDetails.intermediaryServicingAddressDetails;
        if (this.newPolicyDetails.ModeOfOperation === 'NilEndorsement') {
          delete this.newPolicyDetails.brmsResponseObject;
          delete this.newPolicyDetails.premiumObjectofBrms;
          delete this.oldPolicyDetails.brmsResponseObject;
          delete this.oldPolicyDetails.premiumData;
          this.newPolicyDetails.employeeWageDetails.forEach(empDel => {
            delete empDel.riskGrade;
            delete empDel.modifiedRiskGrade;
            delete empDel.riskCode;
            delete empDel.riskPreference;
            delete empDel.erstwhileTariffRate;
            delete empDel.erstwhileTariffRateNetPremium;
            delete empDel.filedRate;
            delete empDel.filedRateNetPremium;

          });
          this.oldPolicyDetails.employeeWageDetails.forEach(empoldDel => {
            delete empoldDel.riskGrade;
            delete empoldDel.modifiedRiskGrade;
            delete empoldDel.riskCode;
            delete empoldDel.riskPreference;
            delete empoldDel.erstwhileTariffRate;
            delete empoldDel.erstwhileTariffRateNetPremium;
            delete empoldDel.filedRate;
            delete empoldDel.filedRateNetPremium;

          });
        }
        if (this.oldPolicyDetails.conditions) {
          delete this.oldPolicyDetails.conditions;
        }
        if (this.oldPolicyDetails.clauses) {
          delete this.oldPolicyDetails.clauses;
        }
        if (this.newPolicyDetails.clauses) {
          delete this.newPolicyDetails.clauses;
        }
        if (this.newPolicyDetails.conditions) {
          delete this.newPolicyDetails.conditions;
        }
        if (this.oldPolicyDetails.customerDetails.dateOfBirth) {
          this.oldPolicyDetails.customerDetails.dateOfBirth = this.datepipe.transform(
            this.oldPolicyDetails.customerDetails.dateOfBirth,
            'dd/MM/yyyy'
          );
        }
        this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity),
          ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity));
        this.diffArray = this.commonMethodService.refactoredJsonObj.filter(array => array.value2 !== '' && !this.fieldNameArray.includes(array.key));
      }
      if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
        this.previousPolicyData = [];
        this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
        if (this.previousPolicyData.length > 0) {
          this.previousPolicyData.forEach(policyRecord => {
            if (policyRecord.PastClaimLodged == "false") {
              policyRecord.PastClaimLodged = "N";
            } else if (policyRecord.PastClaimLodged == "true") {
              policyRecord.PastClaimLodged = "Y";
            }
          });
        }

        this.previousPolicyData.forEach(element => {
          this.policyData = element;
          this.causeofLoss.forEach(causeofLoss => {
            if (element.ClaimRemarks == causeofLoss) {
              this.policyData.causeOfLossForPolicy = element.ClaimRemarks;
            }
          });
          if (this.policyData.causeOfLossForPolicy == '' || this.policyData.causeOfLossForPolicy == undefined) {
            this.policyData.causeOfLossForPolicy = 'Others'
            this.policyData.causeofOtherForPolicy = element.ClaimRemarks;
          }
          this.policyList.push(JSON.parse(JSON.stringify(this.policyData)));
        });
        if (!('conditions' in this.customerProposalTotalResponse)) {
          this.customerProposalTotalResponse.conditions = [];
        }
      }
      //console.log(this.customerProposalTotalResponse);
      if (this.customerProposalTotalResponse.status == 'Rejected by Customer' || this.customerProposalTotalResponse.status == 'EN Rejected by Customer') {
        this.ifProposalRejected = true;
      } else if
        (this.customerProposalTotalResponse.status == 'Payment Pending' || this.customerProposalTotalResponse.status == 'EN Pending Payment') {
        this.ifProposalAccepted = true;
        this.isCheckSelected = true;
      } else if (this.customerProposalTotalResponse.status == 'Endorsement Passed') {
        this.ifEndorsementPassed = true
        this.isCheckSelected = true;
      } else if (this.customerProposalTotalResponse.status == 'EN Pending QC' || this.customerProposalTotalResponse.status == 'QC Approved') {
        this.isCheckSelected = true;
        this.isENPendingQC = true;
      }
      else if (this.customerProposalTotalResponse.status == 'In force' || this.customerProposalTotalResponse.status == 'Pending QC') {
        this.isCustomerProposalMakePaymentSuccess = true;
      }
      else if (this.customerProposalTotalResponse.status == '') {
        this.isCustomerProposalMakePaymentSuccess = true;
      }
      if (this.customerProposalTotalResponse.isAgentPayment == true) {
        this.ifRequestAgentToPayment = true;
      } else {
        this.ifRequestAgentToPayment = false;
      }
      if (this.customerProposalTotalResponse.isPaymentBehalfCustomer) {
        this.isPaymentBehalfCustomer = false;
      } else {
        this.isPaymentBehalfCustomer = true;
      }
      if (this.ifProposalAccepted == true || this.customerProposalTotalResponse.status == 'In force') {
        this.isCheckSelected = true;
      }
      this.tooltipInit();
    }
    );
  }
  mapCoverages() {
    for (const coverage in this.customerDetailsList.coverages) {
      const coverageItem = Object.assign({}, this.coverageItem);
      switch (coverage) {
        case 'stfi': coverageItem.coverageName = 'STFI';
          coverageItem.sumInsured = this.customerDetailsList.coverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'earthquakeCoverage': coverageItem.coverageName = 'EarthQuake(Fire+Shock) coverage';
          coverageItem.sumInsured = this.customerDetailsList.coverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'addOnCoverages': this.mapAddOnCoverages();
      }
    }
  }
  // async getCCWEInfo() {
  //   this.newQuoteService.getCCWEInfo().subscribe(res => {
  //     this.CCWEInfo = res;
  //     //console.log("ccwe-", this.CCWEInfo);
  //   });
  // }

  isNumber(event: KeyboardEvent) {
    const pattern = /[0-9.]/;
    const inputChar = event.key;
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  mapAddOnCoverages() {
    for (const coverage in this.customerDetailsList.coverages.addOnCoverages) {
      const coverageItem = Object.assign({}, this.coverageItem);
      switch (coverage) {
        case 'terroismDamage': coverageItem.coverageName = 'Terrorism Damage';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'terroismForAddOnCover': coverageItem.coverageName = 'Terrorism for Addon Cover';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'forestFire': coverageItem.coverageName = 'Forest Fire';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'architectsSurveyorsEngineersFee': coverageItem.coverageName = 'Architects, Surveyors and Consulting Engineers Fees ( in excess of 3% claim amount)';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'removalOfDebris': coverageItem.coverageName = 'Removal of Debris (in excess of 1% claim amount)';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'impactDamageDueToInsuredOwnRailRoadVehicles': coverageItem.coverageName =
          'Impact Damage due to Insured\'s own Rail/Road Vehicles, Fork lifts, Cranes, Stackers and the like and articles dropped therefrom';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage]['impactDamagesuminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'omissionToInsureAdditions': coverageItem.coverageName = 'Omission to Insure additions, alterations or extensions';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'suminsured'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          this.coveragesList.push(coverageItem);
          break;
        case 'lossOfRentClause': coverageItem.coverageName = 'Loss Of Rent clause';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'Amount'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          coverageItem.indemnityPeriod = this.customerDetailsList.coverages.addOnCoverages[coverage][coverage + 'Months'];
          this.coveragesList.push(coverageItem);
          break;
        case 'insuranceOfAdditionalExpensesOfRentForAnAlternativeAccommodation':
          coverageItem.coverageName = 'Insurance Of Additional Expenses of  Rent For An Alternative Accommodation';
          coverageItem.sumInsured = this.customerDetailsList.coverages.addOnCoverages[coverage]['insuranceOfAdditionalExpensesOfRentAmount'];
          coverageItem.sumInsured = this.commonMethodService.formatNumberToINR(coverageItem.sumInsured);
          coverageItem.indemnityPeriod = this.customerDetailsList.coverages.addOnCoverages[coverage]['insuranceOfAdditionalExpensesOfRentMonths'];
          this.coveragesList.push(coverageItem);
          break;
      }
    }
  }
  mapPremiumBreakUpForAddonCovers(premiumData) {

    for (const coverage of premiumData.BlockCovers) {
      switch (coverage.coverName) {
        case 'Terrorism Cover': this.premiumBreakUpAddonCovglist[0][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Addon Terrorism Cover': this.premiumBreakUpAddonCovglist[1][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Forest Fire': this.premiumBreakUpAddonCovglist[2][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Architects  Surveyors and Consulting Engineers Fees': this.premiumBreakUpAddonCovglist[3][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Loss  of Rent Clause': this.premiumBreakUpAddonCovglist[4][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Insurance  of Additional Expenses of rent for an alternative accommodation': this.premiumBreakUpAddonCovglist[5][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Removal  of Debris': this.premiumBreakUpAddonCovglist[6][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'STFI': this.premiumBreakUpBasicCovglist[1][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
        case 'Earthquake': this.premiumBreakUpBasicCovglist[2][1] = parseFloat(coverage.coverPremium).toFixed(2);
          break;
      }
    }
  }

  mapPremiumBreakUpForBasicCovers(premiumData) {
    if ('RiskCovers' in premiumData) {
      for (const coverage of premiumData.RiskCovers) {
        switch (coverage.coverName) {
          case 'Basic Cover For Fire': this.premiumBreakUpBasicCovglist[0][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
          case 'Impact Damage due to Insureds own Rail or Road Vehicles Forklifts Cranes Stackers and the like': this.premiumBreakUpAddonCovglist[7][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
          case 'Omission to Insure additions alteration or extensions': this.premiumBreakUpAddonCovglist[8][1] = parseFloat(coverage.coverPremium).toFixed(2);
            break;
        }
      }
    }
    this.premiumBreakUpBasicCovglist[0][1] = parseFloat(premiumData.basicPremium).toFixed(2);
    //console.log(this.premiumBreakUpBasicCovglist);
    //console.log(this.premiumBreakUpAddonCovglist);
  }
  getNumberInDecimal(value) {
    return parseFloat(value).toFixed(2);
  }
  gettoken() {
    this.commonService.getToken().subscribe(
      (res) => {
        this.token = res;
        // this.customerProposal();
      },
      (error: HttpErrorResponse) => {
        // this.customerProposal();
      }
    );
  }

  rejectProposalButton() {
    this.customerRejectCommentsDetails.comment = '';
    this.isCustomerRejectionCommentsInvalid = false;
  }

  rejectProposal() {

    if (this.customerProposalTotalResponse.status == 'Rejected by Customer') {
      this.ifProposalRejected = true;
    } else {
      if (this.customerRejectCommentsDetails.comment == '') {
        this.isCustomerRejectionCommentsInvalid = true;
        return;
      }
      if (this.customerDetailsList.customerDetails.customerType == 'I') {
        this.rejectCustomerProposal.customerName = this.customerDetailsList.customerDetails.firstName + ' ' + this.customerDetailsList.customerDetails.lastName;
        this.rejectCustomerProposal.customerLastName = this.customerDetailsList.customerDetails.lastName;
      } else {
        this.rejectCustomerProposal.customerName = this.customerDetailsList.customerDetails.nameOfCorporate;
        this.rejectCustomerProposal.customerLastName = this.customerDetailsList.customerDetails.nameOfCorporate;
      }

      this.rejectCustomerProposal.proposalNo = this.customerProposalTotalResponse.proposalNumber;
      if (this.customerDetailsList.intermediaryDetails.salutation == '') {
        this.rejectCustomerProposal.salutation = 'MR';
      } else {
        this.rejectCustomerProposal.salutation = this.customerDetailsList.intermediaryDetails.salutation;
      }
      this.rejectCustomerProposal.partnerMobileNumber = this.customerDetailsList.intermediaryDetails.mobileNumber;
      this.rejectCustomerProposal.productName = this.customerDetailsList.product;
      this.rejectCustomerProposal.status = 'Rejected by Customer';
      this.rejectCustomerProposal.proposalCreatedBy = this.customerDetailsList.intermediaryDetails.IntermediaryID;
      this.rejectCustomerProposal.intermediaryID = this.customerDetailsList.intermediaryDetails.IntermediaryID;
      this.rejectCustomerProposal.partnerLastName = this.customerDetailsList.intermediaryDetails.firstName == undefined ? "" : this.customerDetailsList.intermediaryDetails.firstName;
      this.rejectCustomerProposal.partnerEmail = this.customerDetailsList.intermediaryDetails.emailId;
      this.customerRejectCommentsDetails.createdBy = this.rejectCustomerProposal.customerName;
      this.customerRejectCommentsDetails.userCode = this.customerDetailsList.customerDetails.customerID;
      this.rejectCustomerProposal.productId = "3611";
      this.rejectCustomerProposal.productName = "EmployeeCompensationInsurance";
      this.rejectCustomerProposal.endorsmentNumber = this.customerProposalTotalResponse.endorsementNumber;
      this.rejectCustomerProposal.modeofOperation = this.customerDetailsList.ModeOfOperation;

      this.customerRejectCommentsDetails.time = formatDate(new Date(), 'dd/MM/yyyy h:mm:ss a', 'en-us');
      this.rejectCustomerProposal.custCommentsDetails.push(this.customerRejectCommentsDetails);

      this.commonService.rejectCustomerProposalForWC(this.rejectCustomerProposal).subscribe(success => {
        this.ifProposalRejected = true;
        this.disabled = true
        $('#RejectProposal').modal('hide');
        $("div").removeClass("arya-modal-backdrop");
        $("div").removeClass("modal-backdrop");
        $(document.body).removeClass("arya-modal-open modal-open");
      },
        error => {
        }
      );
    }
  }

  acceptedProposal() {
    this.emptyFieldError = false;
    if (this.customerDetailsForValidateOtpParams.otp == '') {
      this.emptyFieldError = true;
    } else {
      this.isOTPInvalid = false;
      this.isOTPTimedOut = false;
      this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID;
      this.customerDetailsForValidateOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
      this.customerDetailsForValidateOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
      this.customerDetailsForValidateOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
      this.customerDetailsForValidateOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
      this.customerDetailsForValidateOtpParams.productId = "3611";
      this.customerDetailsForValidateOtpParams.productName = "EmployeeCompensationInsurance";
      if (this.tempProposalNumber.includes('EN')) {
        this.customerDetailsForValidateOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      } else {
        this.customerDetailsForValidateOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
      }


      this.customerProposalService.validateOtpForCustomerproposalAcceptance(this.customerDetailsForValidateOtpParams).subscribe((res) => {
        switch (res) {
          case 'OTP Valid': this.proposalInput.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
            //console.log(this.customerDetailsList)
            setTimeout(() => {
              if (this.tempProposalNumber != undefined) {
                this.customerProposal(this.tempProposalNumber);
              }
            }, 5000);

            this.todayDate = new Date(); //Today Date.
            this.todayDate1 = this.datePipe.transform(this.todayDate, 'dd/MM/yyyy')
            this.todayDate = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy');
            this.risk_date = this.customerDetailsList.policyStartDate.substring(3, 5) + '-' + this.customerDetailsList.policyStartDate.substring(0, 2) + '-' + this.customerDetailsList.policyStartDate.substring(6)
            this.risk_date = this.datePipe.transform(this.risk_date, 'MM/dd/yyyy');
            if (new Date(this.risk_date) < new Date(this.todayDate)) {
              this.customerDetailsList.policyStartDate = this.todayDate;
            }

            if (this.isEndorsement) {
              //this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
              //this.isPaymentByAgentBehalfIndicator = res;
              this.customerProposalService.getWCCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
                if (res.status == 'EN Pending QC' || res.status == 'QC Approved') {
                  this.isCheckSelected = true;
                  this.isENPendingQC = true;
                }
                $('#AcceptProposal').modal('hide');
                $("div").removeClass("arya-modal-backdrop");
                $("div").removeClass("modal-backdrop");
                $(document.body).removeClass("arya-modal-open modal-open");
                // this.ifProposalAccepted = true;
                if (this.isEndorsement && this.customerDetailsList.EndorsementName == 'Any Other Nil Endorsement') {
                  this.ifEndorsementPassed = true;
                  this.ifProposalAccepted = false;

                }
                else {
                  this.ifProposalAccepted = true;
                }
              });
            }
            else {
              this.customerProposalService.getPaymentByAgentBehalfIndicator(this.proposalInput).subscribe(res => {
                this.isPaymentByAgentBehalfIndicator = res;
                $('#AcceptProposal').modal('hide');
                $("div").removeClass("arya-modal-backdrop");
                $("div").removeClass("modal-backdrop");
                $(document.body).removeClass("arya-modal-open modal-open");
                // this.ifProposalAccepted = true;
                if (this.isEndorsement && this.customerDetailsList.EndorsementName == 'Any Other Nil Endorsement') {
                  this.ifEndorsementPassed = true;
                  this.ifProposalAccepted = false;
                }
                else {
                  this.ifProposalAccepted = true;
                }
              });
            }
            break;
          case 'OTP Invalid': this.isOTPInvalid = true;
            this.isOTPTimedOut = false;
            break;
          case 'OTP Expired': this.isOTPTimedOut = true;
            this.isOTPInvalid = false;
            break;
        }
      });
    }
  }

  convertNumberToINR(numToInr) {
    return this.commonMethodService.formatNumberToINR(numToInr);
  }

  editCustomerproposal() {
    this.isEditCustomerProposal = true;
    this.selectedEndorsementType();
    this.getMasterDataForQuote();
    this.tooltipInit();
    setTimeout(() => {
      this.tooltipInit();
    }, 3000);
    this.customerProposalService.getWCCustomerProposalDetails(this.copyOfProposalNumber).subscribe((res: any) => {
      this.customerProposalEditParams = res.inputRequest;
      this.customerProposalEditParams.customerDetails.panNumber = this.customerProposalEditParams.customerDetails.panNumber;

      if (this.customerProposalEditParams && this.customerProposalEditParams.financier.financierDetails.length == 0) {
        this.financierDetails.agreementType = '';
        this.financierDetails.financierName = '';
        this.financierDetails.financierAddress = '';
        this.financierDetails.loanAccountNumber = '';
        this.customerProposalEditParams.financier.financierDetails.push(this.financierDetails);
      }
      //console.log("customerProposalEditParams", this.customerProposalEditParams);
      if (this.customerProposalEditParams.coverages.medicalExpenses.sumInsured == undefined || this.customerProposalEditParams.coverages.medicalExpenses.sumInsured == null) {
        this.addedCoverage = false;
      }
      this.customerProposalEditParams.sumInsured = this.commonMethodService.formatNumberToINR(this.customerProposalEditParams.employeeWageSummary.sumInsured);
      this.customerProposalList.proposalNumber = res.proposalNumber;
      this.customerProposalRateList = res;
      this.policyStartDate = this.customerProposalRateList.policyStartDate.split(' ')[0];
      this.policyStartDate = this.policyStartDate.substring(6) + '-' + this.policyStartDate.substring(3, 5) + '-' + this.policyStartDate.substring(0, 2);
      this.customerTypeMapping();
      this.customerTypeReMapping();
      if (this.customerProposalEditParams.policyStartDate.includes('/')) {
        let policyStartDate = this.customerProposalEditParams.policyStartDate;
        policyStartDate = policyStartDate.substring(6) + '-' + policyStartDate.substring(3, 5) + '-' + policyStartDate.substring(0, 2);
        this.customerProposalEditParams.policyStartDate = policyStartDate;
      }
      if (this.customerProposalEditParams.policyEndDate.includes('/')) {
        let policyEndDate = this.customerProposalEditParams.policyEndDate;
        policyEndDate = policyEndDate.substring(6) + '-' + policyEndDate.substring(3, 5) + '-' + policyEndDate.substring(0, 2);
        this.customerProposalEditParams.policyEndDate = policyEndDate;
      }
      this.customerProposalEditParams.policyEndDate = this.datepipe.transform(
        this.customerProposalEditParams.policyEndDate,
        'yyyy-MM-dd');
      if (this.customerProposalEditParams.customerDetails.dateOfBirth.includes('/')) {
        let cdob = this.customerProposalEditParams.customerDetails.dateOfBirth;
        cdob = cdob.substring(6) + '-' + cdob.substring(3, 5) + '-' + cdob.substring(0, 2);
        this.customerProposalEditParams.customerDetails.dateOfBirth = this.datepipe.transform(
          cdob,
          'yyyy-MM-dd'
        );;
        this.DateofBirthEditProposal = this.customerProposalEditParams.customerDetails.dateOfBirth;
      }
      this.financierList = res.inputRequest.financier.financierDetails;
      if (this.financierList && this.financierList.length == 0) {
        this.financierDetails.agreementType = '';
        this.financierDetails.financierName = '';
        this.financierDetails.financierAddress = '';
        this.financierDetails.loanAccountNumber = '';
        this.financierList.push(this.financierDetails);
      }
      this.customer = res.inputRequest.customerDetails.customerType;
      if ('mailingPinCode' in this.customerProposalEditParams.mailingAddress && this.customerProposalEditParams.mailingAddress.mailingPinCode != '') {
        this.selectPincode(this.customerProposalEditParams.mailingAddress.mailingPinCode);
      }
    });
  }

  makePayment() {
    let imdcode = this.customerDetailsList.intermediaryDetails.IntermediaryID
    this.createQuoteService.validateIMDDealStatus(imdcode).subscribe(res => {
      if (res) {
        // if (res.toUpperCase() != 'ACTIVE') {
        //   this.notifyService.showError('Kindly raise SR accordingly. ', res + " For IMD code " + imdcode);
        //   return;
        // }


        this.pastPaymentPolicy = false;
        this.todayDate = new Date(); //Today Date.
        this.todayDate = this.datePipe.transform(this.todayDate, 'MM/dd/yyyy');
        this.risk_date = this.customerDetailsList.policyStartDate.substring(3, 5) + '-' + this.customerDetailsList.policyStartDate.substring(0, 2) + '-' + this.customerDetailsList.policyStartDate.substring(6)

        this.risk_date = this.datePipe.transform(this.risk_date, 'MM/dd/yyyy');
        if (new Date(this.risk_date) < new Date(this.todayDate)) {
          this.pastPaymentPolicy = true;
          return;
        } else {
          this.pastPaymentPolicy = false;
        }
        this.customerProposalService.getWCCustomerProposalDetails(this.tempProposalNumber).subscribe((payres: any) => {
          // this.customerDetailsList = payres;
          localStorage.setItem('gc_proposalNo', payres.gcProposalNumber);
          localStorage.setItem('CustomerID', payres.customerId);
          localStorage.setItem('officeCode', payres.inputRequest.OfficeCode)
          this.isCustomerProposalMakePayment = true;
          this.inputForPayment.paymentDetails.amount = this.customerProposalTotalResponse.brmsResponse.totalPremium.split(".")[0];
          this.inputForPayment.paymentDetails.emailAddress = this.customerDetailsList.customerDetails.emailId;
          if (this.customerDetailsList.customerDetails.customerType == 'C' || this.customerDetailsList.customerDetails.customerType == 'G') {
            this.inputForPayment.paymentDetails.firstName = this.customerDetailsList.customerDetails.nameOfCorporate;

          } else {
            this.inputForPayment.paymentDetails.firstName = this.customerDetailsList.customerDetails.firstName;

          }
          this.inputForPayment.paymentDetails.phoneNumber = this.customerDetailsList.customerDetails.mobileNumber.toString();
          this.inputForPayment.paymentDetails.proposalNo = localStorage.getItem('ProposalNumber');
          this.inputForPayment.paymentDetails.productInfo = this.customerDetailsList.product;
          if (this.isEndorsement) {
            localStorage.setItem('paymentForEndorsement', 'yes');
            localStorage.setItem('endorsementNumber', this.tempProposalNumber);
          }
          else {
            localStorage.setItem('paymentForEndorsement', 'no');
          }
          this.paymentService.getTransactionId().subscribe(
            (res) => {
              this.inputForPayment.paymentDetails.transactionId = res.toString();
              this.inputForPayment.paymentDetails.proposalNoList = [this.inputForPayment.paymentDetails.proposalNo];
              this.createQuoteService.makePayment(this.inputForPayment).subscribe(
                (res) => {
                  const myWindow = window.open('', '_self');
                  myWindow.document.write(res);
                },
                (error: String) => {
                  this.proposalLists = this.inputForPayment.paymentDetails.proposalNo
                  if (error.includes("We")) {
                    this.duplicatePaymentPolicy = true;
                  } else {
                    this.duplicatePaymentPolicy = false;
                  }
                  this.notifyService.showError(error, 'Payment Notification');
                }
              );
            },
            (error: HttpErrorResponse) => {
            }
          );
        });
      }
    });
  }

  public NumberOnlyInput(event) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onCheckTerms() {
    this.isCheckSelected = !this.isCheckSelected;
  }


  scrollToCustomerTypeField() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "#customerType"
    );

    if (firstInvalidControl != null) {
      if (!firstInvalidControl.closest(".panel-collapse") &&
        firstInvalidControl.closest(".panel-collapse").classList.contains("show")) {
        firstInvalidControl.closest(".panel-collapse").classList.add("show");
      }
      this.scrollToElement(firstInvalidControl);
      $(firstInvalidControl).focus();

      // firstInvalidControl.focus(); //without smooth behavior
    }
  }


  validateCustomerType() {
    this.customerProposalService.validateCustomerType(this.customerProposalTotalResponse.proposalNumber).subscribe(res => {
      if (this.customerDetailsList && this.customerDetailsList.customerDetails.customerType != res) {
        this.customerTypeError = true;
        let cutomerType;
        if (res == "I") {
          cutomerType = "Individual";
        } else if (res == "C") {
          cutomerType = "Corporate";
        } else if (res == "G") {
          cutomerType = "GOVT.UNDERTAKING";
        }
        this.scrollToCustomerTypeField();
        this.notifyService.showError('kindly check and correct customer type.', 'Customer id already exist as ' + cutomerType);
        return;
      } else {
        this.customerTypeError = false;
        this.getOtpForProposalAcceptance();
      }
    });
  }

  getOtpForProposalAcceptance() {
    this.newQuoteService.getCustomerCommunicationProposal(this.customerProposalTotalResponse.proposalNumber).subscribe(res => {
      if (res) {
        this.customerCommunicationDetails = res;
        if (this.isCheckSelected == true) {
          $('#AcceptProposal').modal('show');
          this.customerDetailsForValidateOtpParams.otp = '';
          this.isOTPInvalid = false;
          this.isOTPTimedOut = false;
          // this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID = "" ? this.commonService.getUserName() : this.customerDetailsList.customerDetails.customerID;
          this.customerDetailsForGetOtpParams.customerId = this.customerDetailsList.customerDetails.customerID === "" ? this.commonService.getUserName() : this.customerDetailsList.customerDetails.customerID;

          if (this.customerDetailsList.customerDetails.customerType == 'C' || this.customerDetailsList.customerDetails.customerType == 'G') {
            this.customerDetailsForGetOtpParams.customerLastName = this.customerDetailsList.customerDetails.nameOfCorporate;
          } else {
            this.customerDetailsForGetOtpParams.customerLastName = this.customerDetailsList.customerDetails.lastName;
          }
          this.customerDetailsForGetOtpParams.salutation = this.customerDetailsList.customerDetails.salutation;
          this.customerDetailsForGetOtpParams.proposalNumber = this.customerProposalTotalResponse.proposalNumber;
          this.customerDetailsForGetOtpParams.emailId = this.customerDetailsList.customerDetails.emailId;
          this.customerDetailsForGetOtpParams.mobileNumber = this.customerDetailsList.customerDetails.mobileNumber;
          this.customerDetailsForGetOtpParams.productId = "3611";
          this.customerDetailsForGetOtpParams.productName = "EmployeeCompensationInsurance";
          this.customerDetailsForGetOtpParams.emailIndicator = this.customerCommunicationDetails.emailIndicator === null ? false : this.customerCommunicationDetails.emailIndicator;
          this.customerDetailsForGetOtpParams.smsIndicator = this.customerCommunicationDetails.smsIndicator === null ? false : this.customerCommunicationDetails.smsIndicator;
          this.customerDetailsForGetOtpParams.whatsappIndicator = this.customerCommunicationDetails.whatsAppIndicator === null ? false : this.customerCommunicationDetails.whatsAppIndicator;
          this.customerDetailsForGetOtpParams.partnerCopyIndicator = this.customerCommunicationDetails.partnerCopyIndicator === null ? false : this.customerCommunicationDetails.partnerCopyIndicator;
          // this.customerDetailsForGetOtpParams.paymentBehalfIndicator = this.customerCommunicationDetails.paymentBehalfIndicator === null ? false : this.customerCommunicationDetails.paymentBehalfIndicator;

          this.customerDetailsForGetOtpParams.modeofOperation =
            this.customerProposalTotalResponse.inputRequest.ModeOfOperation === ""
              ? 'SaveProposal'
              : this.customerProposalTotalResponse.inputRequest.ModeOfOperation;


          if (this.tempProposalNumber.includes('EN')) {
            this.customerDetailsForGetOtpParams.endorsementNumber = this.customerProposalTotalResponse.endorsementNumber;
            this.customerDetailsForGetOtpParams.modeofOperation = this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
          } else {
            this.customerDetailsForGetOtpParams.modeofOperation =
              this.customerProposalTotalResponse.inputRequest.ModeOfOperation === ""
                ? 'SaveProposal'
                : this.customerProposalTotalResponse.inputRequest.ModeOfOperation;
          }
          this.customerDetailsForGetOtpParams.panNumber = this.customerProposalTotalResponse.inputRequest.customerDetails.panNumber;

          this.customerProposalService.getOtpForCustomerproposalAcceptanceForWC(this.customerDetailsForGetOtpParams).subscribe((res) => {
            this.acceptProposalOtpResponse = res;
          });
        } else {
          this.notifyService.showError('Please confirm the declaration before accepting the proposal', 'Customer Profile Notification');
        }
      }
    });
  }

  updateTransactionDetailsAfterPayment() {
    this.proposalsToPolicyParams.proposalNos.push(localStorage.getItem('gc_proposalNo'));
    this.proposalsToPolicyParams.partnerproposalNos.push(localStorage.getItem('ProposalNumber'));
    // this.proposalsToPolicyParams.officeCode = '9400401';
    this.proposalsToPolicyParams.officeCode = '9' + localStorage.getItem('officeCode');
    this.proposalsToPolicyParams.paymentBy = 'CUSTOMER';
    // this.proposalsToPolicyParams.transactionDetails.amount = this.paymentResponse.amount;
    //this.proposalsToPolicyParams.transactionDetails.email = this.paymentResponse.email;
    //this.proposalsToPolicyParams.transactionDetails.error = this.paymentResponse.error;
    //this.proposalsToPolicyParams.transactionDetails.hashCode = this.paymentResponse.hash;
    //this.proposalsToPolicyParams.transactionDetails.mId = this.paymentResponse.mihpayid;
    //this.proposalsToPolicyParams.transactionDetails.mode = this.paymentResponse.mode;
    this.proposalsToPolicyParams.transactionDetails.payerCustomerId = localStorage.getItem('CustomerID');
    //this.proposalsToPolicyParams.transactionDetails.pgType = this.paymentResponse.PG_TYPE;
    this.proposalsToPolicyParams.transactionDetails.status = this.paymentResponse.status;
    this.proposalsToPolicyParams.transactionDetails.transactionId = this.paymentResponse.txnid;
    //this.proposalsToPolicyParams.transactionDetails.unmappedStatus = this.paymentResponse.unmappedstatus;
    if (this.proposalsToPolicyParams.transactionDetails.status == 'success') {
      if (localStorage.getItem('paymentForEndorsement') == 'yes') {
        this.router.navigate(['/wc-customerproposal'],
          {
            queryParams: { proposalNo: localStorage.getItem('endorsementNumber') }
          });
        this.tempProposalNumber = localStorage.getItem('endorsementNumber');
        this.isEndorsement = this.tempProposalNumber.includes('EN') ? true : false;
        this.isEndorsement ? this.proposalInput['endorsmentNumber'] = this.tempProposalNumber : this.proposalInput['proposalNumber'] = this.tempProposalNumber;
        this.getUploadedDocuments(this.tempProposalNumber);
      }
      this.isCustomerProposalMakePaymentSuccess = true;
      this.notifyService.showSuccess('After payment processed policy will be shared soon', 'Payment Notification');
      this.commonService.getToken().subscribe(
        (token) => {
          this.proposalsToPolicyParams.tokenId = token;
          this.commonService.convertProposalToPolicyOnPaymentSuccess(this.proposalsToPolicyParams).subscribe(paymentres => {
            this.notifyService.showSuccess(paymentres + '.', 'Policy Notification');
            if (this.isEndorsement) {
              this.newQuoteService.disablePreviousCommunication(this.tempProposalNumber).subscribe(res => { })
            }
            setTimeout(() => {
              this.tooltipInit();

              this.customerProposalService.getCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
                this.customerDetailsList = res.inputRequest;
                if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
                  this.previousPolicyData = [];
                  this.policyList = [];
                  this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
                  this.previousPolicyData.forEach(element => {
                    this.policyData = element;
                    this.causeofLoss.forEach(causeofLoss => {
                      if (element.ClaimRemarks == causeofLoss) {
                        this.policyData.causeOfLossForPolicy = element.ClaimRemarks;
                      }
                    });
                    if (this.policyData.causeOfLossForPolicy == '' || this.policyData.causeOfLossForPolicy == undefined) {
                      this.policyData.causeOfLossForPolicy = 'Others'
                      this.policyData.causeofOtherForPolicy = element.ClaimRemarks;
                    }
                    this.policyList.push(JSON.parse(JSON.stringify(this.policyData)));
                  });
                }
                this.customerProposalTotalResponse = res;
                if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
                  this.newPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.inputRequest.InputXML));
                  this.oldPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.oldPolicyDetails.inputRequest.InputXML));
                  delete this.oldPolicyDetails.intermediaryDetails;
                  delete this.newPolicyDetails.intermediaryDetails;
                  delete this.oldPolicyDetails.intermediaryServicingAddressDetails;
                  delete this.newPolicyDetails.intermediaryServicingAddressDetails;
                  if (this.newPolicyDetails.ModeOfOperation === 'NilEndorsement') {
                    delete this.newPolicyDetails.brmsResponseObject;
                    delete this.newPolicyDetails.premiumObjectofBrms;
                    delete this.oldPolicyDetails.brmsResponseObject;
                    delete this.oldPolicyDetails.premiumData;
                  }
                  if (this.oldPolicyDetails.customerDetails.dateOfBirth) {
                    this.oldPolicyDetails.customerDetails.dateOfBirth = this.datepipe.transform(
                      this.oldPolicyDetails.customerDetails.dateOfBirth,
                      'dd/MM/yyyy'
                    );
                  }
                  this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity),
                    ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity));

                }

              });
            }, 5000);
          }, () => {
            this.notifyService.showError('Sorry, your payment could not be processed!', '');
          });
        });
    }
  }

  onChangeValidateCoverageLimits(fieldName) {
  }

  onChangeRisktype() {

  }

  onChangeCustomerType(customerType) {
    if (customerType == 'Individual' || customerType == 'I') {
      this.commonService.getSalutation('Individual').subscribe(res => {
        this.salutationList = res;
        this.salutationList = this.salutationList.keyValuePairList.keyValuePairList;
      });
    } else {
      this.salutationList = [{
        name: 'M/S'
      }
      ];
      this.customerProposalEditParams.customerDetails.salutation = 'M/S'

    }
  }
  getCustomerTypeList() {
    this.commonService.getCustomerType().subscribe(res => {
      this.customerTypeList = res;
    });
  }
  CancelEditButton() {
    this.isEditCustomerProposal = false;
    this.isCheckSelected = false;
    setTimeout(() => {
      this.tooltipInit();
    }, 1000);
  }
  getMasterDataForQuote() {
    this.lineOfBusinessCode = 36;
    let imdcode = this.customerDetailsList.intermediaryDetails.IntermediaryID;
    let userRole = this.customerDetailsList.UserRole;
    this.commonService.getMasterDataForMarine(this.lineOfBusinessCode, this.productCode, imdcode, userRole).subscribe((res) => {
      this.masterDataForQuote = res;
      // //console.log(this.masterDataForQuote)
    });
  }
  agreementTypeData() {
    this.commonService.agreementTypeData().subscribe(res => {
      this.agreementData = res;
    });
  }
  saveEditCustomerProposal(form: NgForm) {
    this.scrollToFirstInvalidControl();
    var valid = this.financierDetailsComponent.checkFormValid() ? form.disabled ? true : form.valid : false;
    if (valid && !this.pincodeminlimit && !this.notfound) {
      if (this.customerProposalEditParams.typeOfBusiness == 'Roll Over' ? !this.previousPolicyFormValid : true) {
        this.submitted = true;
        if (this.customerProposalEditParams.typeOfBusiness == 'Roll Over') {
          this.PreviousPolicyDetailsComponent.policydetailsMapping();
          this.customerProposalEditParams.PASTPOLICY['PASTPOLICYDETAILS'] = JSON.parse(JSON.stringify(this.PreviousPolicyDetailsComponent.previousPolicyData));
          this.customerProposalEditParams.PASTPOLICY['PASTPOLICYDETAILS'].forEach(item => {
            const policyStartYear = parseFloat(item.PreviousPolicyStartdate.toString().substring(0, 4));
            const policyStartMonth = parseFloat(item.PreviousPolicyStartdate.toString().substring(5, 7));
            const policyStartDate = parseFloat(item.PreviousPolicyStartdate.toString().substring(8));
            const startDate = new Date(policyStartYear, policyStartMonth - 1, policyStartDate);
            item.PreviousPolicyStartdate = this.datepipe.transform(
              startDate,
              'dd/MM/yyyy'
            );
            const policyEndYear = parseFloat(item.PreviousPolicyEnddate.toString().substring(0, 4));
            const policyEndMonth = parseFloat(item.PreviousPolicyEnddate.toString().substring(5, 7));
            const policyEndDate = parseFloat(item.PreviousPolicyEnddate.toString().substring(8));
            const endDate = new Date(policyEndYear, policyEndMonth - 1, policyEndDate);
            item.PreviousPolicyEnddate = this.datepipe.transform(
              endDate,
              'dd/MM/yyyy'
            );
            //console.log(this.customerProposalEditParams.PASTPOLICY)
          });
        }
        //this.financierDetailsComponent.validateFinanceirDetailsForm(true);
        this.financierDetailsFormValid = true;
        if (this.financierDetailsFormValid) {
          this.customerProposalEditParams['ProposalNumber'] = this.customerProposalList.proposalNumber;
          // this.customerProposalEditParams['policyStartDate'] = this.datepipe.transform(
          //   this.customerProposalEditParams.policyStartDate,
          //   'dd/MM/yyyy'
          // );
          // this.customerProposalEditParams['policyEndDate'] = this.datepipe.transform(
          //   this.customerProposalEditParams.policyEndDate,
          //   'dd/MM/yyyy'
          // );
          this.customerProposalEditParams.customerDetails['dateOfBirth'] = this.datepipe.transform(
            this.customerProposalEditParams.customerDetails.dateOfBirth,
            'dd/MM/yyyy'
          );
          // this.customerProposalEditParams['customerDetails']['dateOfBirth'] = this.DateofBirthEditProposal;
          // this.customerProposalEditParams['customerDetails']['dateOfBirth'] = this.datepipe.transform(
          //   this.customerProposalEditParams['customerDetails']['dateOfBirth'],
          //   'dd/MM/yyyy'
          // );

          if (this.customerProposalEditParams.customerDetails.customerType == 'Individual') {
            this.customerProposalEditParams.customerDetails.customerType = 'I';
          } else if (this.customerProposalEditParams.customerDetails.customerType == 'Corporate') {
            this.customerProposalEditParams.customerDetails.customerType = 'C';
            this.customerProposalEditParams.customerDetails.dateOfBirth = '';
          } else if (this.customerProposalEditParams.customerDetails.customerType == 'Govt.Undertaking') {
            this.customerProposalEditParams.customerDetails.customerType = 'G';
          }
          if (this.customerProposalEditParams.customerDetails.customerType == 'C' || this.customerProposalEditParams.customerDetails.customerType == 'G') {
            this.customerProposalEditParams.customerDetails.dateOfBirth = '';
          }
          const cloneOfcustomerProposalEditParams = JSON.parse(JSON.stringify(this.customerProposalEditParams));

          cloneOfcustomerProposalEditParams.customerDetails.panNumber = cloneOfcustomerProposalEditParams.customerDetails.panNumber;

          cloneOfcustomerProposalEditParams.financier.financierDetails = cloneOfcustomerProposalEditParams.financier.financierDetails.filter(finacierDetail => finacierDetail.agreementType != ''
            && finacierDetail.financierAddress != '' && finacierDetail.financierName != '');

          //console.log("locations=", this.customerProposalEditParams.riskDetails.riskAddress.riskLocations);
          // this.customerProposalEditParams.sumInsured = this.commonMethodService.convertToPureNumber(this.customerProposalEditParams.sumInsured)
          this.customerProposalService.saveWCEditCustomerProposalDetails(cloneOfcustomerProposalEditParams)
            .subscribe(
              res => {
                this.isEditCustomerProposal = false;
                this.isCheckSelected = false;
                this.customerProposalService.getWCCustomerProposalDetails(this.copyOfProposalNumber).subscribe((res: any) => {
                  this.customerDetailsList = res.inputRequest;
                  if (this.customerDetailsList.financier.financierDetails && this.customerDetailsList.financier.financierDetails.length == 0) {
                    this.financierDetails.agreementType = '';
                    this.financierDetails.financierName = '';
                    this.financierDetails.financierAddress = '';
                    this.financierDetails.loanAccountNumber = '';
                    this.customerDetailsList.financier.financierDetails.push(this.financierDetails);
                  }
                  if (this.customerDetailsList.typeOfBusiness == 'Roll Over') {
                    this.previousPolicyData = [];
                    this.policyList = [];
                    this.previousPolicyData = this.customerDetailsList.PASTPOLICY['PASTPOLICYDETAILS'];
                    this.previousPolicyData.forEach(element => {
                      this.policyData = element;
                      this.causeofLoss.forEach(causeofLoss => {
                        if (element.ClaimRemarks == causeofLoss) {
                          this.policyData.causeOfLossForPolicy = element.ClaimRemarks;
                        }
                      });
                      if (this.policyData.causeOfLossForPolicy == '' || this.policyData.causeOfLossForPolicy == undefined) {
                        this.policyData.causeOfLossForPolicy = 'Others'
                        this.policyData.causeofOtherForPolicy = element.ClaimRemarks;
                      }
                      this.policyList.push(JSON.parse(JSON.stringify(this.policyData)));
                    });
                  }
                  this.customerProposalTotalResponse = res;
                  if ('oldPolicyDetails' in this.customerProposalTotalResponse) {
                    this.newPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.inputRequest));
                    this.oldPolicyDetails = JSON.parse(JSON.stringify(this.customerProposalTotalResponse.oldPolicyDetails.inputRequest));
                    delete this.oldPolicyDetails.intermediaryDetails;
                    delete this.newPolicyDetails.intermediaryDetails;
                    delete this.oldPolicyDetails.intermediaryServicingAddressDetails;
                    delete this.newPolicyDetails.intermediaryServicingAddressDetails;
                    if (this.newPolicyDetails.ModeOfOperation === 'NilEndorsement') {
                      delete this.newPolicyDetails.brmsResponseObject;
                      delete this.newPolicyDetails.premiumObjectofBrms;
                      delete this.oldPolicyDetails.brmsResponseObject;
                      delete this.oldPolicyDetails.premiumData;
                    }
                    if (this.oldPolicyDetails.customerDetails.dateOfBirth) {
                      this.oldPolicyDetails.customerDetails.dateOfBirth = this.datepipe.transform(
                        this.oldPolicyDetails.customerDetails.dateOfBirth,
                        'dd/MM/yyyy'
                      );
                    }
                    this.commonMethodService.filterAndAddBothValues(((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.oldPolicyDetails)).flat())).flat(Infinity),
                      ((this.commonMethodService.arrangeDataArr(this.commonMethodService.getKeyValues(this.newPolicyDetails)).flat())).flat(Infinity));
                  }
                  this.notifyService.showSuccess('Customer Profile updated successfully', 'Customer Profile Notification');
                }
                );
                setTimeout(() => {
                  this.tooltipInit();
                }, 1000);

                setTimeout(() => {
                  this.tooltipInit();
                }, 4000);
              }
            );
        }
      }
    }
    else {
      this.notifyService.showError('One or more field value is either invalid or missing', 'Form validation')
    }
  }

  customerTypeMapping() {
    if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'I') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'INDIVIDUAL';
    } else if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'C') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'CORPORATE';
    } else if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'G') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'GOVT.UNDERTAKING';
    }
  }
  customerTypeReMapping() {
    this.customerProposalRateList.inputRequest.customerDetails['customerType'] = this.customerProposalRateList.inputRequest.customerDetails['customerType'].toUpperCase();
    if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'INDIVIDUAL') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'Individual';
      this.onChangeCustomerType('I');
    } else if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'CORPORATE') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'Corporate';
      this.onChangeCustomerType('C');
    } else if (this.customerProposalRateList.inputRequest.customerDetails['customerType'] == 'GOVT.UNDERTAKING') {
      this.customerProposalRateList.inputRequest.customerDetails['customerType'] = 'Govt.Undertaking';
      this.onChangeCustomerType('G');
    }
    this.customerProposalRateList.inputRequest.customerDetails['salutation'] = this.customerProposalRateList.inputRequest.customerDetails['salutation'].toUpperCase();
  }
  onKeyUpValidationForField(fieldName) {
    switch (fieldName) {
      case 'dob':
        if ((new Date().getFullYear() - new Date(this.customerProposalEditParams.customerDetails.dateOfBirth).getFullYear()) < 18) {
          this.isDobInvalid = true;
        } else {
          this.isDobInvalid = false;
        }
        break;
      case 'dobFuture':
        if (
          (new Date(this.customerProposalEditParams.customerDetails.dateOfBirth)) > (new Date(this.getToday()))
        ) {
          this.dobFutureDate = true;
        } else {
          this.dobFutureDate = false;
        }
        break;
      case 'policyDate':
        if ((new Date(this.policyStartDate)) < (new Date(this.getToday()))
        ) {
          this.isPolicyStartDate = true;
        } else {
          this.isPolicyStartDate = false;
        }
        break;
      case 'emailId':
        const pattern = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.([a-zA-Z]{2,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/;
        const inputString = this.customerProposalEditParams['customerDetails']['emailId'];
        if (pattern.test(inputString)) {
          this.isEmailIdInValid = false;
        } else {
          this.isEmailIdInValid = true;
        }
        break;
      case 'alternateEmailId':
        const patternAl = /[a-zA-Z0-9._%+-]+@[a-zA-Z0-9]+\.([a-zA-Z]{2,5}|[a-zA-z]{2,5}\.[a-zA-Z]{2,5})/;
        const inputStringAl = this.customerProposalEditParams['customerDetails']['alternateEmailId'];
        if (patternAl.test(inputStringAl)) {
          this.isAlEmailIdInValid = false;
        } else {
          this.isAlEmailIdInValid = true;
        }
        break;
      case 'mobileNumber1':
        const patternmb1 = /^[6-9.][0-9]{9}$/;
        const inputStringmb1 = this.customerProposalEditParams['customerDetails']['mobileNumber'];
        if (patternmb1.test(inputStringmb1)) {
          this.isMobilenumberInValid = false;
        } else {
          this.isMobilenumberInValid = true;
        }
        break;
      case 'mobileNumber2':
        const patternmb2 = /^[6-9.][0-9]{9}$/;
        const inputStringmb2 = this.customerProposalEditParams['customerDetails']['alternateMobileNumber'];
        if (patternmb2.test(inputStringmb2)) {
          this.isMobilenumber2InValid = false;
        } else {
          this.isMobilenumber2InValid = true;
        }
        break;
      default:
        break;
    }
  }


  enEffectiveDate() {
    return this.datepipe.transform(
      this.getToday(),
      'dd/MM/yyyy'
    );
  }

  adjustPolicyEndDate() {
    if (this.customerProposalEditParams.policyPeriod == '') {
      this.customerProposalEditParams.policyPeriod = '';
      this.policyStartDate = null;
      return;
    }
    if (this.policyStartDate == '' || this.policyStartDate == null) {
      this.date = new Date();
      const year = this.date.getFullYear();
      const month = this.date.getMonth();
      const day = this.date.getDate();
      const policyStartDate = new Date(year, month, day);
      this.policyStartDate = this.datepipe.transform(
        policyStartDate,
        'yyyy-MM-dd');
    }
    const policyStartYear = parseFloat(this.policyStartDate.toString().substring(0, 4));
    const policyStartMonth = parseFloat(this.policyStartDate.toString().substring(5, 7));
    const policyStartDate = parseFloat(this.policyStartDate.toString().substring(8));
    const years = parseInt(this.customerProposalEditParams.policyPeriod.match(/\d+/)[0]);
    const endDate = new Date(policyStartYear + years, policyStartMonth - 1, policyStartDate);
    endDate.setDate(endDate.getDate() - 1);
    this.policyEndDateToSavePeoposal = this.datepipe.transform(
      endDate,
      'yyyy-MM-dd');
    // this.customerProposalEditParams.InputXML.policyEndDate = this.policyStartDate;
    this.customerProposalEditParams.policyStartDate = this.policyStartDate;
    this.policyStartDate = this.customerProposalEditParams.policyStartDate;
    this.customerProposalEditParams.policyEndDate = this.policyEndDateToSavePeoposal;
    this.customerProposalEditParams.policyEndDate = this.datepipe.transform(
      this.policyEndDateToSavePeoposal,
      'yyyy-MM-dd');
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  getToolTipMsgFor(toolTipFor) {
    switch (toolTipFor) {
      case 'Terrorism Damage': return '“Terrorism damage” is terrorism cover for basic coverage';
        break;
      case 'Terrorism for Addon Cover': return '“Terrorism for add on” is terrorism cover for add on covers';
        break;
      case 'Architects, Surveyors and Consulting Engineers Fees ( in excess of 3% claim amount)':
        return 'The expenses incurred on the fee of mentioned professionals in case of damage by Insured peril is covered by this add-on.';
        break;
      case 'Removal of Debris (in excess of 1% claim amount)':
        return 'Cost incurred to remove debris followed by damage by Insured Perils is covered by this add-on.';
        break;
      case 'Omission to Insure additions, alterations or extensions':
        return 'This add on provides protection for any addition, alternation or extension' +
          ' to the existing property (other than stocks) that the Insured erect or add during the currency of policy at covered risk location.';
        break;
      case 'Loss Of Rent clause':
        return 'Loss of Rent covers the loss of income in the form of rent receivable when the insured property has been rented out and it becomes uninhabitable due to occurrence of an Insured Event.';
        break;
      case 'Insurance Of Additional Expenses of  Rent For An Alternative Accommodation':
        return 'Covers the additional cost for an alternate accommodation which the insured may incur in case the occupied property becomes uninhabitable due to occurrence of an Insured Peril.';
        break;
      default: return null;
        break;
    }
  }
  selectPincode(item) {
    this.isPinCodeValid = true;
    if (item.length == '6') {
      this.newQuoteService.getPincodeDataOnSelect(item).subscribe(res => {
        if (res != null) {
          this.notfound = false;
          this.pincodeminlimit = false;
          if (Object.keys(res).length != 0) {
            this.customerProposalEditParams.mailingAddress['mailingPinCode'] = item;
            this.PincodeMasterData = res;
            this.customerProposalEditParams['mailingAddress']['mailingDistrict'] = this.PincodeMasterData.cityDistrictName;
            this.customerProposalEditParams['mailingAddress']['mailingDistrictCd'] = this.PincodeMasterData.cityDistrictCode;
            this.customerProposalEditParams['mailingAddress']['mailingState'] = this.PincodeMasterData.stateName;
            this.customerProposalEditParams['mailingAddress']['mailingStateCd'] = this.PincodeMasterData.stateCode;
            this.customerProposalEditParams['mailingAddress']['mailingTownOrCity'] = this.PincodeMasterData.cityDistrictName;
            this.customerProposalEditParams.LocationID = this.PincodeMasterData.locationCode;
          } else {
            this.pinCodeSearchCleared();
          }
        } else {
          this.notfound = true;
        }
      });
    }
  }
  requestAgentPayment() {
    this.customerProposalService.requestAgentToMakePayment(this.tempProposalNumber).subscribe((res: any) => {
      this.ifRequestAgentToPayment = true;
    }
    );
  }

  onChangePincodeData(val: string) {
    this.isPinCodeValid = true;
    if (val.trim() != '') {
      this.promise = new Promise<void>((resolve, reject) => {
        if (val.length <= 5) {
          this.pinCodeminError();
        } else if (val.length == 6) {
          this.pinCodeminError4();
        }

        else if (val.length == 0 || val.length == null) {
          this.pinCodeminError3();
        }
        else if (val.length > 6) {
          this.pinCodeminError1();
        }
        if (val.length >= 3) {
          this.newQuoteService.getPincodeMasterData(val)
            .toPromise()
            .then(
              res => {
                this.PinCodeList = res;

                if (this.PinCodeList.length == 0) {
                  this.pinCodeSearchCleared();
                }

                resolve();
              }
            );
        }
      });
    }
    return this.promise;
  }
  pinCodeminError() {
    this.pincodeminlimit = true;
    this.notfound = false
  }
  pinCodeminError1() {
    this.pincodeminlimit = true;
    this.notfound = false
  }
  pinCodeminError3() {
    this.pincodeminlimit = true;
    this.notfound = false
  }
  pinCodeminError4() {
    this.pincodeminlimit = false;
    this.notfound = false
  }
  pinCodeSearchCleared() {
    this.PincodeMasterData = null;
    this.PinCodeList = null;
    this.isPinCodeValid = false;
  }
  uploadedDocumentCount = 0;
  uploadedDocumentList;
  docDataSet = {};
  uploadedFilesList = [];
  prepareUploadedFileData() {
    const uniqueDocTypeList = [];
    if (this.uploadedDocumentCount > 0) {
      this.uploadedDocumentList.forEach(docData => {
        if (!(uniqueDocTypeList.indexOf(docData.docType) > -1)) {
          uniqueDocTypeList.push(docData.docType);
        }
      });
      for (const docType of uniqueDocTypeList) {
        this.docDataSet[docType] = this.uploadedDocumentList.filter(docData => docData.docType == docType);
      }
      for (const docType in this.docDataSet) {
        const docListObj = new UploadedFileObj();
        docListObj.docName = docType;
        let temp = [];
        temp = this.docDataSet[docType];
        docListObj.docsCount = temp.length;
        if (docListObj.docsCount == 1) {
          docListObj.docRealFileName = temp[0].actualFileName;
        }
        temp.forEach((doc, index, temp) => {

          if ('docComment' in doc) {
            if (doc['docComment'] != '') {
              docListObj.comments = docListObj.comments + doc['docComment'] + ';';
            }
          }
          if (index == 0) {
            docListObj.lastUploadedBy = doc['uploadedby'];
            docListObj.lastUploadedDate = doc['date'];
            if (temp.length == 1) {
              docListObj.uuid = doc['uuid'];
            }
          } else {
            if (new Date(docListObj.lastUploadedDate) < new Date(doc['date'])) {
              docListObj.lastUploadedDate = doc['date'];
              docListObj.lastUploadedBy = doc['uploadedby'];
            }
          }
        });
        this.uploadedFilesList.push(docListObj);
      }
    }
  }


  getUploadedDocuments(proposalNumber) {
    this.newProposalService.getUploadedDocuments(proposalNumber).subscribe(res => {
      this.uploadedDocumentList = res;
      this.uploadedDocumentCount = this.uploadedDocumentList != null ? this.uploadedDocumentList.length : 0;
      this.prepareUploadedFileData();
    });
  }

  formatdocName(docName) {
    return docName.replace(/_/g, ' ');
  }

  downloadAll() {
    if (this.isEndorsement) {
      this.downloadAllKey = this.customerProposalTotalResponse.endorsementNumber;
    } else {
      this.downloadAllKey = this.proposalInput['proposalNumber'];
    }
    if (this.uploadedDocumentCount > 1) {
      this.newProposalService.getAllDocumentZip(this.downloadAllKey).subscribe(res => {
        this.loaderService.show();
        setTimeout(() => {
          this.downloadZIPBase64File(this.downloadAllKey + 'All_Files', res['base64String']);
          this.loaderService.hide();
        }, 10000);
      });
    } else {
      if (this.uploadedDocumentCount == 1) {
        this.newProposalService.getAllDocumentZip(this.downloadAllKey).subscribe(res => {
          this.loaderService.show();
          setTimeout(() => {
            this.downloadAnyBase64File(res['mimeType'], res['base64String'], res['docType']);
            this.loaderService.hide();
          }, 10000);
        });
      }
    }
  }


  downloadFile(documentCount, uuid, fileType, docRealName) {
    if (documentCount == 1) {
      this.newProposalService.getDocumentByUUID(uuid).subscribe(res => {
        if (res['mimeType'] == '') {
          res['mimeType'] = res['physicalFileName'].substring(res['physicalFileName'].lastIndexOf('.') + 1);
          switch (res['mimeType']) {
            case 'xlsx':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
              break;
            case 'xls':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.ms-excel';
              break;
            case 'doc':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/msword';
              break;
            case 'docx':
              docRealName = docRealName + '.' + res['mimeType'];
              res['mimeType'] = 'application/vnd.openxmlformats-officedocument.wordprocessingm';
              break;
            default:
              break;
          }
        }
        this.downloadAnyBase64File(res['mimeType'], res['base64String'], docRealName);
      });
    } else {
      if (documentCount > 1) {
        this.newProposalService.getDocSetZip(this.proposalInput['proposalNumber'], fileType).subscribe(res => {
          this.loaderService.show();
          setTimeout(() => {
            this.downloadZIPBase64File(fileType, res['base64String']);
            this.loaderService.hide();
          }, 10000);
        });
      }
    }
  }

  public async downloadZIPBase64File(filename: string, content: string) {
    const zip = new JSZip();
    await zip.loadAsync(content, { base64: true });
    const blob = await zip.generateAsync({ type: "blob" });

    const element = document.createElement("a");
    element.setAttribute("href", window.URL.createObjectURL(blob));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  downloadAnyBase64File(contentType, base64Data, fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement('a');
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  selectedEndorsementType() {
    if (this.customerProposalTotalResponse.status == 'EN Pending Consent' || this.isEndorsement) {
      this.disableAllEn = true;
      if (this.customerDetailsList && this.customerDetailsList.EndorsementTypes) {
        this.customerDetailsList.EndorsementTypes.forEach(endorsementType => {
          switch (endorsementType) {
            case 'Inclusion  of Financier':
              this.isInclusionofFinancierChecked = true;
              break;
            case 'Any other Nil Endorsement':
              this.isAnyOtherNilEndorsementChecked = true;
              this.isInclusionofFinancierChecked = true;
              break;
            case 'Change in Client Details':
              this.isChangeinClientDetailsChecked = true;
              break;
            case 'Update GSTN':
              this.isUPDateGSTNChecked = true;
              break;
            case 'Addition of Occupancy/Risk':
              this.isAdditionOccupancyChecked = true;
              break;
            case 'Increase in No of Employee/Wages':
              this.isIncreaseinEmployeesChecked = true;
              break;
            default:
              break;
          }
          // this.isInclusionofFinancierChecked = (endorsementType == 'Inclusion  of Financier') ? true : false;
          // this.isAnyOtherNilEndorsementChecked = (endorsementType == 'Any Other Nil Endorsement') ? true : false;
          // this.isChangeinClientDetailsChecked = (endorsementType == 'Change in Client Details') ? true : false;

        });
      }
    }
  }
  validateDisplayEditButtonForEndorsement() {
    this.endorsementType = this.customerDetailsList.EndorsementName;
    if (this.customerDetailsList && this.customerDetailsList.EndorsementTypes) {
      if (this.customerDetailsList.EndorsementTypes.includes('Any Other Nil Endorsement') ||
        this.customerDetailsList.EndorsementTypes.includes('Inclusion  of Financier') ||
        this.customerDetailsList.EndorsementTypes.includes('Change in Client Details')) {
        this.displayEditButtonForEndorsement = true;
      }
      else {
        this.displayEditButtonForEndorsement = false;
      }
    }
  }



  onCoverageValueChange(event, index) {
    if (event === '') {
      this.coveragesList[index].added = false;
    }
  }


  toggleCover() {
    if (this.addedCoverage) {
      this.customerProposalEditParams.coverages.medicalExpenses.sumInsured = '';
    }
    this.addedCoverage = this.customerProposalEditParams.coverages.medicalExpenses.sumInsured != '' && this.customerProposalEditParams.coverages.medicalExpenses.sumInsured != undefined;

    // if (this.customerProposalEditParams.coverages.medicalExpenses.sumInsured == undefined || this.customerProposalEditParams.coverages.medicalExpenses.sumInsured == null) {
    //   this.addedCoverage = false;
    // }

  }

  checkIfCoverageValueExist(index) {
    if (this.coveragesList[index].sumInsuredValue != '') {
      this.coveragesList[index].added = !this.coveragesList[index].added;
      if (!this.coveragesList[index].added) {
        this.coveragesList[index].sumInsuredValue = '';
      }
    } else {
      this.coveragesList[index].added = false;
      this.coveragesList[index].sumInsuredValue = '';
    }
  }
  getWCProposalCoveragesList() {
    this.newProposalService.getCoveragesListForWCProposal(36, 3611).subscribe(response => {
      this.coveragesList = response;
      this.coveragesList.map(coverage => coverage.added = false);
      this.coveragesList.map(coverage => (coverage.showCoverage = (this.commonService.getUserRole() == 'UNDERWRITING') ? true : (coverage.modelValue == 'medicalExpenses')));
      if (this.customerProposalTotalResponse && this.customerProposalTotalResponse.inputRequest && this.customerProposalTotalResponse.inputRequest.coverages) this.updateCoverages(this.customerProposalTotalResponse.inputRequest.coverages);
    });
  }
  updateCoverages(coveragesObject) {
    let coverageList: any = JSON.parse(JSON.stringify(this.coveragesList));
    let coverageKeys = Object.keys(coveragesObject.addOnCoverages);
    coverageList.forEach(coverage => {
      coverageKeys.forEach(key => {
        if (coverage.modelValue == key && coverage.modelValue != 'medicalExpenses') {
          coverage.sumInsuredValue = (coveragesObject.addOnCoverages[key].sumInsured).toString().indexOf(',') == -1 ? coveragesObject.addOnCoverages[key].sumInsured : this.commonMethodService.convertToPureNumber(coveragesObject.addOnCoverages[key].sumInsured);
          coverage.showCoverage = true;
          coverage.added = true;
        }
      })
      if (coverage.modelValue === 'medicalExpenses') {
        if (coveragesObject.medicalExpenses.sumInsured) {
          coverage.sumInsuredValue = (coveragesObject.medicalExpenses.sumInsured).toString().indexOf(',') == -1 ? coveragesObject.medicalExpenses.sumInsured : this.commonMethodService.convertToPureNumber(coveragesObject.medicalExpenses.sumInsured);
          coverage.added = true;
        }
      }
    })
    this.coveragesList = JSON.parse(JSON.stringify(coverageList));
    //console.log(this.coveragesList);
  }
  showTextCount(businessDescription) {
    this.textCountFor = this.customerProposalEditParams.riskDetails['businessDescription'].length;
  }
  showTextCountReject(businessDescription) {
    //this.textCountForReject = this.customerRejectCommentsDetails.comment?.length;
  }
  getPolicyDataForDownload(policyNumber, status) {
    this.policyNumberToDownload = policyNumber;
    if (this.commonMethodService.convertPolicyStatusToPPFormat(status) == 'Endorsement Passed') {
      this.commonService.downloadEndorsementPolicy(this.policyNumberToDownload).subscribe(res => {
        const dataForPDF: any = res;
        this.blob = new Blob([dataForPDF], { type: 'application/pdf' });
        const downloadURL = window.URL.createObjectURL(this.blob);
        const link = document.createElement('a');
        link.href = downloadURL;
        link.download = this.policyNumberToDownload + '.pdf';
        link.click();
      })
    } else {
      this.customerProposalService.getWCCustomerProposalDetails(this.tempProposalNumber).subscribe((res: any) => {
        if (res.policyNumber != '') {
          this.policyNumberToDownload = res.policyNumber
          // this.commonService.getPolicyDataToDownload(policyNumber).subscribe(policyDetails => {
          this.commonService.downloadPolicyForWc(this.policyNumberToDownload).subscribe(res => {
            // const dataForPDF: any = res;
            // this.blob = new Blob([dataForPDF], { type: 'application/pdf' });
            // const downloadURL = window.URL.createObjectURL(res);
            // const link = document.createElement('a');
            // link.href = downloadURL;
            // link.download = this.policyNumberToDownload + '.pdf';
            // link.click();
            this.downloadAnyBase64File("application/pdf", res["base64String"], res["fileName"]);

          });
          // });
        } else {
          this.notifyService.showError('Please wait until you receive Email communication about your Policy', '')
        }
      }
      );
    }
  }

  getPolicyDataForDownloadEndorsement(endorsementNumbertoDownload) {
    this.commonService.downloadEndorsementPolicy(endorsementNumbertoDownload).subscribe(res => {
      const dataForPDF: any = res;
      this.blob = new Blob([dataForPDF], { type: 'application/pdf' });
      const downloadURL = window.URL.createObjectURL(this.blob);
      const link = document.createElement('a');
      link.href = downloadURL;
      link.download = endorsementNumbertoDownload + '.pdf';
      link.click();
    })
  }
  noPopupRejectProposal(customerRejectCommentsDetails) {
    customerRejectCommentsDetails.comment = "";
  }

  camelCaseToSentenceCase(text) {
    let cutText = text;
    cutText = text.replace(text, text.includes('.') ? text.split('.')[1] : text)
    //console.log(cutText);
    const result = cutText.replace(/([A-Z])/g, " $1");
    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    if (finalResult.includes('Gstin Number')) {
      finalResult = finalResult.replace('Gstin Number', 'GSTIN Number')
    }
    if (finalResult.includes('Pan Number')) {
      finalResult = finalResult.replace('Pan Number', 'PAN Number')
    }

    return finalResult;
  }

}